import { Button, Column, Row } from 'components/Blocks';
import { CircleCheckIcon } from 'components/Blocks/Icons';
import { Coin } from 'components/DecorativeIcons';

import { Trans, useLang } from 'locale';
import { useUser } from 'providers/Auth';

interface RedeemSuccessProps {
  close(): void;
}

export function RedeemSuccess({ close }: RedeemSuccessProps) {
  const { t } = useLang();
  const { activeIncentive } = useUser();

  return (
    <Column
      alignItems="center"
      className="text-center duration-300 animate-in fade-in-0 slide-in-from-bottom-6"
    >
      <CircleCheckIcon size={40} color="success" variant="filled" />

      <h4 className="text-success">{t('redeem-success.title')}</h4>

      <p className="mx-auto max-w-[90%] [&_strong]:underline">
        <Trans textKey="redeem-success.wait" />
      </p>

      <p className="mx-auto max-w-[90%]">{t('redeem-success.email-info')}</p>

      <p>{t('redeem-success.contacts')}</p>

      <Row justifyContent="center">
        <Coin size={36} />
        <h2 className="text-lg font-medium">
          {t('remaining-balance')}: <strong className="text-warning">{activeIncentive}</strong>{' '}
          {t('points')}
        </h2>
      </Row>

      <Button className="mx-auto mt-2 w-full max-w-[80%]" onClick={close}>
        {t('close')}
      </Button>
    </Column>
  );
}
